module.exports = "/packs/images/svg/facilities/trampoline~6e519117ad30844116a7ef0bfeafa483.svg";